import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useParams, Link } from "react-router-dom";
import "./EventParticipants.css";

const EventParticipants = () => {
  const { eventId } = useParams();
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchParticipants = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/events/${eventId}/results/`);
        // 参加者 (is_participating === true)
        const filtered = res.data.filter(
          (p) => p.is_participating === true || p.isParticipating === true
        );
        setParticipants(filtered);
      } catch (err) {
        console.error("データ取得エラー:", err);
        alert("参加者リストの取得に失敗しました。");
      } finally {
        setLoading(false);
      }
    };
    fetchParticipants();
  }, [eventId]);

  if (loading) return <p className="text-center mt-4">読み込み中...</p>;

  return (
    <div className="container mt-4">
      <h2 className="mb-4 text-center">参加者一覧</h2>
      {participants.length === 0 ? (
        <p className="text-center">参加者がまだいません。</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped table-hover">
            <thead className="table-success">
              <tr>
                <th style={{ width: "15%" }}>社員コード</th>
                <th style={{ width: "25%" }}>氏名</th>
                <th style={{ width: "30%" }}>部署</th>
                <th style={{ width: "30%" }}>職種</th>
              </tr>
            </thead>
            <tbody>
              {participants.map((p, i) => (
                <tr key={i}>
                  <td>{p.memberId}</td>
                  <td>{p.employeeName}</td>
                  <td>{p.departmentName || "-"}</td>
                  <td>{p.employeeType || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="text-center mt-4">
        <Link to="/admin/create_event" className="btn btn-secondary">
          戻る
        </Link>
      </div>
    </div>
  );
};

export default EventParticipants;